import {
  ControlDefinition as UnifiedControlDefinition
} from "@makeswift/controls";
function isLegacyDescriptor(control) {
  return !(control instanceof UnifiedControlDefinition);
}
export {
  isLegacyDescriptor
};
//# sourceMappingURL=descriptors.js.map